import { render, staticRenderFns } from "./contactWay.vue?vue&type=template&id=2d5c8916&scoped=true&"
import script from "./contactWay.vue?vue&type=script&lang=ts&"
export * from "./contactWay.vue?vue&type=script&lang=ts&"
import style0 from "./contactWay.vue?vue&type=style&index=0&id=2d5c8916&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5c8916",
  null
  
)

export default component.exports